import React from 'react';
import { ActionListGridFormRowAction } from '@broadleaf/admin-components/dist/collection/components/ActionListGrid/action-components/ActionListGridFormRowAction';
import { useRowWithEdits } from 'app/common/utils/rowEdits';

/**
 * The standard grid row form action, but with values saved by inline grid columns (e.g.
 * INLINE_EDIT_ROW, BOOLEAN_TOGGLE_ROW) applied to the row, so the form opens with them even
 * though the grid hasn't re-fetched its rows.
 */
const InlineEditRowFormAction = props => {
  const row = useRowWithEdits(props.row);
  return <ActionListGridFormRowAction {...props} row={row} />;
};

export { InlineEditRowFormAction };
